export default __webpack_public_path__ + "static/media/payments-history-empty-dark.30339805.png";